import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../middleware/AuthContext'; 
import ChangeAnnouncementPage from '../pages/ChangeAnnouncementPage';
import BreakingNewsAnnouncementPage from '../pages/BreakingNewsAnnouncementPage';
import DistributionListManagement from '../pages/DistributionListManagement';
import HelpPage from '../pages/HelpPage';
import HomePage from '../pages/HomePage';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import NotFoundPage from '../pages/NotFoundPage';
import ForbiddenPage from '../pages/ForbiddenPage'; 
import AnnouncementSubscr from '../pages/AnnouncementSubscr';

const basePath = ''; // Define the base path
// ProtectedRoute component now correctly uses ReactElement as the type for element
const ProtectedRoute: React.FC<{ element: React.ReactElement, roles?: string[] }> = ({ element, roles= [] }) => {
  const { isAuthenticated, userRole, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Loading state while fetching user data
  }

  if (!isAuthenticated) {
    return <Navigate to={`${basePath}/401`} />; // Redirect to Unauthorized page if not logged in
  }

  if (roles.length > 0 && !roles.includes(userRole || '')) {
    return <Navigate to={`${basePath}/403`} />;
  }

  return element; // Return the protected route element if authenticated
};

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Protected Routes */}
        <Route path={`${basePath}/make-announcement/change`} element={<ProtectedRoute element={<ChangeAnnouncementPage />} roles={['viewer', 'editor']} />} />
        <Route path={`${basePath}/make-announcement/breaking-news`} element={<ProtectedRoute element={<BreakingNewsAnnouncementPage />} roles={['viewer', 'editor']} />} />
        <Route path={`${basePath}/distribution-list`} element={<ProtectedRoute element={<DistributionListManagement />} roles={['viewer', 'editor']}/>} />
        <Route path={`${basePath}/subscription`} element={<ProtectedRoute element={<AnnouncementSubscr />} roles={['subscriber']}/>} />
        <Route path={`${basePath}/help`} element={<ProtectedRoute element={<HelpPage />} roles={['viewer', 'editor']}/>} />

        {/* Public Routes */}
        <Route path={`${basePath}/`} element={<HomePage />} />
        
        {/* Error Routes */}
        <Route path={`${basePath}/401`} element={<UnauthorizedPage />} />
        <Route path={`${basePath}/403`} element={<ForbiddenPage />} />
        <Route path={`${basePath}/404`} element={<NotFoundPage />} />

        {/* Catch-all for undefined routes */}
        <Route path="*" element={<Navigate to={`${basePath}/404`} />} /> {/* Fallback to 404 page for undefined routes */}
      </Routes>
    </Router>
  );
};

export default AppRouter;
